import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-be64ead4")

_pushScopeId("data-v-be64ead4")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 利用規約の変更履歴 ")
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _hoisted_2,
    _createVNode("table", null, [
      _createVNode("tr", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.changeHistory.header, (item, index) => {
          return (_openBlock(), _createBlock("th", { key: index }, _toDisplayString(item), 1))
        }), 128))
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.changeHistory.rows, (item, idx) => {
        return (_openBlock(), _createBlock("tr", { key: idx }, [
          _createVNode("td", null, _toDisplayString(item.date), 1),
          _createVNode("td", null, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.content, (subItem, idy) => {
              return (_openBlock(), _createBlock("div", { key: idy }, " ・" + _toDisplayString(subItem), 1))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
})